{
  "cancel": "Anuluj",
  "delete": "Usuń",
  "close": "Zamknij",
  "done": "Zrobione",
  "deleteTitle": "Usunąć rekord?",
  "deleteText": "Trwale usunąć ten rekord?",
  "info": "Informacje",
  "objectInfoTitle": "Informacje o rekordzie",
  "createdBy": "Utworzył(a)",
  "createdAt": "Utworzono dnia",
  "lastEditedBy": "Ostatnio edytował(a)",
  "editedAt": "Edytowano dnia",
  "unknown": "Nieznany",
  "system": "System",
  "objectHistoryTitle": "Rekord i historia",
  "changes": "Zmiany",
  "loadingHistory": "Ładowanie historii…",
  "noHistory": "Brak jeszcze historii zmian.",
  "historyLoadError": "Nie udało się załadować historii.",
  "someone": "Ktoś",
  "historyDate": "Data",
  "historyUser": "Użytkownik",
  "historyChange": "Zmiana",
  "actionCreated": "utworzył(a)",
  "actionDeleted": "usunął(ęła)",
  "actionChanged": "zmienił(a)",
  "historyFallbackWithTitle": "„{{title}}” {{verb}}",
  "historyFallback": "Wpis {{verb}}",
  "updateAvailable": "Dostępna aktualizacja",
  "updateBody": "Dostępna jest nowa wersja tej aplikacji.\nAktualizacja jest wymagana, aby zapewnić najlepsze możliwe działanie.",
  "updateLater": "Zaktualizuj później",
  "updateNow": "Aktualizuj",
  "internetRequired": "(Wymagany Internet)",
  "releaseInfo": "Informacje o wydaniu",
  "selectMandant": "Wybierz firmę",
  "noLicence": "Brak dostępnej licencji",
  "noCompanyAssigned": "Nie jesteś przypisany do żadnej firmy.",
  "companiesLoadError": "Nie udało się załadować firm",
  "logout": "Wyloguj się"
}
